import { render, staticRenderFns } from "./AnchorPanel.vue?vue&type=template&id=3fa3ce90&scoped=true&"
import script from "./AnchorPanel.vue?vue&type=script&lang=js&"
export * from "./AnchorPanel.vue?vue&type=script&lang=js&"
import style0 from "./AnchorPanel.vue?vue&type=style&index=0&id=3fa3ce90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa3ce90",
  null
  
)

export default component.exports